import {
    LoggingActions,
    LoggingActionTypes,
    LoggingState,
} from "#store/logging/loggingTypes";

/*******************************************************************************
 * Logging Reducer
 ******************************************************************************/
function loggingReducer(
    state: LoggingState = { messages: [] },
    action: LoggingActions
): LoggingState {
    switch (action.type) {
        case LoggingActionTypes.LOG_ITEM: {
            return { ...state, messages: [...state.messages, action.payload] };
        }
        default: {
            return state;
        }
    }
}

export { loggingReducer };
